var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid grid-1-1"},[_c('gl-close'),_vm._v(" "),_c('chart-of-accounts')],1),_vm._v(" "),_c('gl-setup'),_vm._v(" "),_c('div',{staticClass:"grid grid-1-1 mt-large"},[_c('gl-cache-rebuild')],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f1191f5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/accounting/general-ledger/settings/GlSettings.vue
// module id = xuun
// module chunks = 0 1